import {Main} from '../../components/main/main.tsx';

export function Information() {
    return <Main>Information</Main>;
}
